module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Thunder-move-42e81863322dc607f956aba8cf48d23c.svg";